import request from '@/config/axios'

export interface NewsVO {
  id: number // 资讯 ID
  categoryId?: number // 分类 ID
  title?: string // 资讯标题
  summary?: string // 摘要/导语
  thumb?: string // 缩略图
  content?: string // 正文内容（富文本）
  author?: string // 作者
  topFlag?: boolean // 排序值（越大越靠前）
  remark?: string // 备注
  userTypeList?: number[] | null // 用户类型列表
  regionIdList?: number[] // 区域 ID 列表
  publishTime?: number // 发布时间
  newsType: number //宣传类别
}

// 查询菜单（精简）列表
export const getNewsPage = (params) => {
  return request.get<any>({ url: '/cms/news/page' ,params})
}
// 查询菜单列表
export const getNewsDetail = (id) => {
  return request.get<NewsVO>({ url: `/cms/news/get?id=${id}` })
}



//////////////////////////通知公告//////////////////////////
export interface NotifyMessageVO {
  id: number
  userId: number
  userType: number
  templateId: number
  templateCode: string
  templateNickname: string
  templateName: string
  templateContent: string
  templateType: number
  templateParams: string
  readStatus: boolean
  createTime: number
}
export const getNotifyMessagePage = async (params: any) => {
  return await request.get({ url: '/system/notify-message/page', params })
}
export const updateNotifyMessageRead = async (params: any) => {
  return await request.get({ url: '/system/notify-message/page', params })
}
